module.exports = __webpack_public_path__ + "img/zu26.0cc8ddc6.png";